export default __webpack_public_path__ + "static/media/combo_wb.01f0cc1a.png";